import { OktaAuth } from '@okta/okta-auth-js';
import getConfig from 'next/config';

import { getPublicStagedConfig } from '../../utils/public/MintedConfig';

const createOktaAuthClient = () => {
  const {
    publicRuntimeConfig,
  } = getConfig();

  const clientId = getPublicStagedConfig(window.location.host, 'clientId');

  return new OktaAuth({
    clientId,
    ignoreLifetime: true,
    issuer: publicRuntimeConfig.oidc?.issuer,
    redirectUri: `${window.location.origin}${publicRuntimeConfig.oidc?.redirectUri}`,
    scopes: publicRuntimeConfig.oidc?.scopes,
  });
};

export default createOktaAuthClient;
